import { SelectItem } from '@mantine/core'

export function generateSelectItem<T>(
  items: Array<T>,
  labelKey: keyof T,
  valueKey: keyof T,
): Array<T & SelectItem> {
  return (items || [])?.map<T & SelectItem>((item) => ({
    ...item,
    label: String(item[labelKey]),
    value: String(item[valueKey]),
  }))
}
